module.exports = __webpack_public_path__ + "static/media/icon-btn-close-dark-2.e7bdef4d.svg";